import React from 'react'
import { Link } from "react-router-dom"
import { Row, Col, Typography, Space, Card } from 'antd'
import Genomics from '../images/genomics-card.png'
import Variations from '../images/variations-card.png'
import Genetics from '../images/genetics.png'
import Populations from '../images/populations.png'
import Download from '../images/tools/download.png'

const { Title } = Typography
const { Meta } = Card

class Resources extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Title level={3} className="resource-title">Resources</Title>
                <Row className="resource-card" gutter={[16]} style={{marginBottom: '16px'}}>
                    <Col span={8}>
                        <Link to="/genomics">
                        <Card cover={ <img alt="genomics" src={Genomics} /> } hoverable >
                            <Meta title={<span><Link to="/genomics">Genomics</Link></span>} description="Collection of tomato reference genome assemblies, annotations and gene expressions." />
                        </Card>
                        </Link>
                    </Col>
                    <Col span={8}>
                        <Link to="/variations">
                        <Card cover={ <img alt="Variations" src={Variations} /> } hoverable >
                            <Meta title={<span><Link to="/variations">Variations</Link></span>} description="Variations including single nucleotide polymorphisms (SNPs), insertion and deletions (InDels)." />
                        </Card>
                        </Link>
                    </Col>
                    <Col span={8}>
                        <Link to="/genetics">
                        <Card cover={ <img alt="Genetics" src={Genetics} /> } hoverable >
                            <Meta title={<span><Link to="/genetics">Genetics</Link></span>} description="Collection of tomato phenotypes and related genetic locus, including GWAS, eQTL and QTL signals." />
                        </Card>
                        </Link>
                    </Col>
                </Row>
                <Row className="resource-card" gutter={[16]}>
                    <Col span={8}>
                        <Link to="/populations">
                        <Card cover={ <img alt="Populations" src={Populations} /> } hoverable >
                            <Meta title={<span><Link to="/populations">Populations</Link></span>} description="Collection of tomato populations and and provides necessary information to understand the population structures." />
                        </Card>
                        </Link>
                    </Col>
                    <Col span={8}>
                        <a href="/tomato/ftp">
                        <Card cover={ <img width="402px" height="161px" alt="Download" src={Download} /> } hoverable >
                            <Meta title={<span><a href="/tomato/ftp">Download</a></span>} description="All genomes can be downloaded." />
                        </Card>
                        </a>
                    </Col>
                    <Col span={8}>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default Resources
